import {StyleSheet} from 'react-native';

import {denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginBottom: 8,
  },
  titleContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  closeButton: {
    alignItems: 'baseline',
    flexDirection: 'row',
  },
  closeButtonIcon: {
    fontSize: 16,
    marginLeft: 8,
    fontWeight: '600',
  },
  closeButtonTitle: {
    color: denim,
    fontWeight: '600',
  },
  loadingBox: {
    width: '100%',
    height: 60,
  },
});
